'use client';

import React, { useEffect, useState } from 'react';

import { BasicFormProps } from '@/interfaces/basicForm';

export const BasicForm = React.forwardRef<any, BasicFormProps>(({ onSubmit = (formData: any) => {}, className = '', children }, ref) => {
  const formOnSubmit = (e: any) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const keys = Array.from(new Set(formData.keys()));
    let data: any = {};
    for (const key of keys) {
      data[key] = Array.from(formData.getAll(key));
    }
    onSubmit(data);
  };
  return (
    <form ref={ref} onSubmit={formOnSubmit} className={`basic-form text-xl ${className}`}>
      {children}
    </form>
  );
});
